module.exports = __webpack_public_path__ + "img/c80433b.jpg";